var GblTop;
function GetVertOffset(srchStr) {
    GblTop = $(srchStr).offset().top;
}

$(function () {
    if ($('body').hasClass('ppc-landing-page')) {
        GetVertOffset('.header-cta');     // -- Sets GblTop
        $(window).scroll(function () {
            GetVertOffset('.header-cta');
            var y = $(window).scrollTop();
            if (y >= GblTop) {
                $('.top-bar-cta-ppc').addClass('fixed-ppc').slideDown(500).fadeIn(125);
            } else {
                $('.top-bar-cta-ppc').removeClass('fixed-ppc').slideUp(500).fadeOut(125);
            }
        });
    }

    $('.accordion2:first-of-type i').addClass('flipped');
    $('.accordion1 .header, .accordion2 .header').on('click', function () {
        var body = $(this).next().next();
        var icon = $(this).next();

        body.slideToggle('500');
        icon.toggleClass('flipped');
    });
});


$(document).ready(function () {
    // wraps scrollable tables on medium and smaller viewports
    function scrollWrap() {
        $('table').wrap('<div class="scroll-wrapper"></div>');
        $('.scroll-wrapper').before('<div class="scroll-header">Swipe to view more content</div>');
    }
    scrollWrap();

    // show or hide table scroll header based on if overflowing its parent
    function handleScrollResize() {
        $('table').each(function (index) {
            var table = $(this);
            var tableWidth = table.outerWidth();
            var parentWidth = table.parent().outerWidth();
            var scrollHeader = table.parent().prevAll('.scroll-header:first');

            if (tableWidth > parentWidth) {
                // element has overflow
                scrollHeader.show();
            } else {
                // element doesn't overflow
                scrollHeader.hide();
            }
        })
    }

    function tableCheck(){
        if ($('div.scroll-wrapper table tbody tr td').is(':empty')) {
            $('div.scroll-wrapper table tbody tr td:not(:nth-of-type(1)):empty').css('background-color','#bebebe');
        }
    }
    tableCheck();

    $(window).on("resize", function () {
        handleScrollResize();
    });

    $(document).ready(function () {
        handleScrollResize();
    });
});